import { Link } from "react-router-dom";
import Seo from "../components/Seo";

export default function NotFound() {
  return (
    <>
      <Seo
        title="Page not found"
        description="The page you're looking for isn't here. Return to the homepage or explore services, areas and guides."
        path="/404"
      />
      <section className="content-hero section-pad narrow" data-testid="not-found">
        <p className="eyebrow">404</p>
        <h1>This page isn't here.</h1>
        <p className="large-copy">
          The page you're looking for doesn't exist or has moved. You can head back to the homepage,
          or browse services, areas and guides from the links below.
        </p>
        <div className="actions-row">
          <Link className="btn btn-primary" to="/" data-testid="404-home-link">Return home</Link>
          <Link className="btn btn-secondary" to="/spa-services-bhubaneswar/" data-testid="404-services-link">Services</Link>
          <Link className="btn btn-secondary" to="/areas/" data-testid="404-areas-link">Area guides</Link>
          <Link className="btn btn-secondary" to="/guides/" data-testid="404-guides-link">Wellness guides</Link>
        </div>
      </section>
    </>
  );
}
